export default "__VITE_ASSET__DZdzs$XX__$_?url__"